/**
 * Maintenance notification configuration constants
 */
export const MAINTENANCE_CONFIG = {
  // Check maintenance status every 1 minute (60000ms) for better responsiveness
  CHECK_INTERVAL: 60000,
  
  // Maintenance page route
  MAINTENANCE_ROUTE: '/maintenence',
  
  // Session storage key for redirect path
  REDIRECT_STORAGE_KEY: 'redirectAfterMaintenance',
  
  // Date formatting options
  DATE_FORMAT_OPTIONS: {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }
};

export const MAINTENANCE_MESSAGES = {
  CONTEXT_ERROR: 'useMaintenanceContext must be used within a MaintenanceProvider',
  DEFAULT_MESSAGE_KEY: 'maintenance_message'
};
